var map = {
	"./Stroke 1.png": 2430,
	"./Why Our Save the Dat.png": 2431,
	"./all_about_shipping@2x.png": 2432,
	"./ask_for_everything@2x.png": 2433,
	"./big-day@1x.png": 2434,
	"./big-day@2x.png": 2435,
	"./birds@1x.png": 2436,
	"./birds@2x.png": 2437,
	"./check-list@1x.png": 2438,
	"./check-list@2x.png": 2439,
	"./circle-better@1x.png": 2440,
	"./circle-better@2x.png": 2441,
	"./empty_rsvp.png": 2442,
	"./empty_rsvp2x.png": 2443,
	"./envelope.png": 954,
	"./envelope.svg": 2444,
	"./envelope@2x.png": 2445,
	"./events_doodle.png": 825,
	"./events_doodle.svg": 2446,
	"./gifts@1x.png": 2447,
	"./gifts@2x.png": 2448,
	"./guest-list@1x.png": 2449,
	"./guest-list@2x.png": 2450,
	"./guest.png": 2451,
	"./guest.svg": 2452,
	"./guest2x.png": 2453,
	"./guest_approved@2x.png": 2454,
	"./invitations@1x.png": 2455,
	"./invitations@2x.png": 2456,
	"./invites_paper.svg": 2457,
	"./invites_paper@1x.png": 2458,
	"./invites_paper@2x.png": 2459,
	"./laptop-one-heart.png": 2460,
	"./laptop-one-heart@2x.png": 2461,
	"./laptop@1x.png": 2462,
	"./laptop@2x.png": 2463,
	"./long-page-checklist.png": 2464,
	"./long-page-checklist@2x.png": 2465,
	"./make_it_personal@2x.png": 2466,
	"./namecard-with-name.png": 2467,
	"./namecard-with-name@2x.png": 2468,
	"./namecard_no_name.svg": 826,
	"./namecard_with_name.svg": 2469,
	"./namecard_with_question_marks.svg": 455,
	"./no_address.png": 2470,
	"./no_address2x.png": 2471,
	"./onboarding_1.png": 2472,
	"./onboarding_1@2x.png": 2473,
	"./onboarding_2.png": 2474,
	"./onboarding_2@2x.png": 2475,
	"./onboarding_3.png": 2476,
	"./onboarding_3@2x.png": 2477,
	"./onboarding_4.png": 2478,
	"./onboarding_4@2x.png": 2479,
	"./red-star-left@1x.png": 2480,
	"./red-star-left@2x.png": 2481,
	"./red-star-right@1x.png": 2482,
	"./red-star-right@2x.png": 2483,
	"./rsvp@1x.png": 2484,
	"./rsvp@2x.png": 2485,
	"./save-the-date@1x.png": 2486,
	"./save-the-date@2x.png": 2487,
	"./sparkle-left.svg": 862,
	"./sparkle-right.svg": 863,
	"./sparkle-up.svg": 869,
	"./ta-da.png": 2488,
	"./ta-da@2x.png": 2489,
	"./talk.svg": 2490,
	"./talk@1x.png": 905,
	"./talk@2x.png": 906,
	"./timeline-line-dark@1x.png": 2491,
	"./timeline-line-dark@2x.png": 2492,
	"./timeline-line@1x.png": 2493,
	"./timeline-line@2x.png": 2494,
	"./tips.svg": 715,
	"./underline_long@1x.png": 2495,
	"./underline_long@2x.png": 2496,
	"./underline_sm@1x.png": 2497,
	"./underline_sm@2x.png": 2498,
	"./website_publish_confetti.svg": 2499,
	"./wedding-websites@1x.png": 2500,
	"./wedding-websites@2x.png": 2501,
	"./wedding_help.png": 969,
	"./wedding_help.svg": 2502,
	"./wedding_help@2x.png": 2503
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 471;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 471
// module chunks = 71